<template>
  <div
    :style="{
      'background-color': useBackgroundColor,
      'padding-top': paddingTop ? paddingTop + 'px' : '',
      'padding-bottom': paddingBottom ? paddingBottom + 'px' : ''
    }"
  >
    <div
      :class="{ 'container': useContainer, 'redirect-block-select': blockParams?.isUrl }"
      @click="$emit('block:redirect')"
    >
      <div class="box-link pg-inf-btn" :style="{ 'background-color': mainFields?.bgColor?.value }">
        <div class="box-link__content">
          <div v-if="mainFields?.image?.value" class="box-link__image" :style="`${ notCenterImage ? 'align-self: start; padding: 0;' : '' }`">
            <img :src="$imageUrl({ fileId: mainFields?.image?.value }, '', 'webp')" alt="">
          </div>
          <div class="box-link__title">
            <!-- eslint-disable-next-line vue/no-v-html -->
            <div class="inj-html el-tiptap-editor__content" v-html="mainFields.text?.value" />
          </div>
        </div>
        <div v-if="mainFields?.link?.value" class="box-link__btn">
          <a
            v-if="mainFields?.link?.value?.startsWith(['https://'])"
            :href="mainFields?.link?.value"
            target="_blank"
            class="btn btn--full btn--mobile-large"
          >
            Подробнее
          </a>
          <nuxt-link
            v-else
            :to="{ path: mainFields?.link?.value?.[0] === '/' ? mainFields?.link?.value : `/${mainFields?.link?.value}` }"
            class="btn btn--full btn--mobile-large"
          >
            Подробнее
          </nuxt-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import staticBlockMixin from '~/mixins/staticBlockMixin'

export default {
  name: 'PageInformationButton',
  mixins: [staticBlockMixin],

  props: {
    notCenterImage: {
      type: Boolean,
      default: false
    }
  }
}
</script>
